import React from "react";
import { NavLink } from "react-router-dom";

function TitansNavbar() {
  return (
  <nav className="navbar navbar-expand-lg p-0 navyBlue mx-auto">
    <div className="container-fluid pt-1">
      {/* <a className="navbar-brand" href="#">Navbar</a> */}
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse justify-content-center w-100" id="navbarNavAltMarkup">
        <div className="navbar-nav">
          <NavLink 
            to="/Titansacademy" 
            end
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
          >
            Home
          </NavLink>
          {/* <NavLink 
            to="/AboutTitans" 
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
          >
            Meet the Team
          </NavLink> */}
          <NavLink 
            to="/TitansEducation" 
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
          >
            Education
          </NavLink>
          <NavLink 
            to="/TitansHousing" 
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
          >
            Housing &amp; Facilities
          </NavLink>
          <NavLink 
            to="/TitansRecruitment" 
            className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
          >
            Recruit Me
          </NavLink>
        </div>
      </div>
    </div>
  </nav>
  );
}

export default TitansNavbar;
